<template>
  <v-row justify="center">
    <v-dialog v-model="dialog.active" width="410">
      <v-card>
        <v-img :src="dialog.src"></v-img>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="onClose()">{{
            $t("components.dialogs.qrCodePreviewDialog.close")
          }}</v-btn>
          <v-btn color="primary" text @click="onDownload()">{{
            $t("components.dialogs.qrCodePreviewDialog.download")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Object,
      default: Object,
    },
  },
  computed: {
    getFormatedBoatNameString() {
      let string = "";
      if (
        typeof this.dialog.boat.model !== "undefined" ||
        typeof this.dialog.boat.device !== "undefined"
      ) {
        string = `${this.dialog.boat.model.brand_name}-${this.dialog.boat.model.model}-${this.dialog.boat.device.name}`;
      }

      return string;
    },
  },
  methods: {
    onClose() {
      this.$emit("close", true);
    },
    onDownload() {
      let link = document.createElement("a");
      let index = this.dialog.src.indexOf(";");
      link.target = "_blank";
      link.download = `qr-code-${this.getFormatedBoatNameString}.png`;
      link.href =
        "data:application/octet-stream;" +
        this.dialog.src.substring(index + 1, this.dialog.src.length);
      document.body.appendChild(link); // Required for Firefox
      link.click();
      link.remove();
      this.$emit("close", true);
    },
  },
};
</script>
<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
